import { ERole } from "../enums/user/ERole";
import { IUser } from "../interfaces/user/IUser";

// API returns { data: IUser }, so roles can be on userData.roles (if flat)
// or on (userData as any).data.roles (if wrapped) — handle both
export const getUserRoles = (userData?: IUser): string[] =>
  userData?.roles ?? (userData as any)?.data?.roles ?? [];

export const hasRole = (userData: IUser | undefined, role: ERole): boolean =>
  getUserRoles(userData).some((r) => r.toLowerCase() === role.toLowerCase());

// Operators have no dashboard, so their landing page is the incident list
export const getHomePath = (userData?: IUser): string =>
  hasRole(userData, ERole.OPERATOR) ? "/incidents" : "/dashboard";
